import { render } from "./ContentPlaceholders.vue?vue&type=template&id=5abad31e&ts=true"
import script from "./ContentPlaceholders.vue?vue&type=script&lang=ts"
export * from "./ContentPlaceholders.vue?vue&type=script&lang=ts"

import "./ContentPlaceholders.vue?vue&type=style&index=0&id=5abad31e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__